module.exports = __webpack_public_path__ + "img/burst-logo-kudo-white.10666dc.png";